import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Projects from '../components/Projects';
import Footer from '../components/Footer';


const MyWork = () => {
    return (
        <>
            <ScrollToTop />
            <Projects />
            <Footer />
        </>
    )
}

export default MyWork